import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "premium-calculator-block__country-info" }
const _hoisted_2 = { class: "block-card block-card--bg-light-grey" }
const _hoisted_3 = { class: "premium-box block-card__content" }
const _hoisted_4 = { class: "block-card__content" }
const _hoisted_5 = { class: "risk-class__heading heading" }
const _hoisted_6 = { class: "risk-class__class" }
const _hoisted_7 = { class: "risk-class__class-heading" }
const _hoisted_8 = { class: "risk-class__indicator" }
const _hoisted_9 = { class: "risk-class__indicator-list" }
const _hoisted_10 = {
  key: 0,
  class: "risk-class__description"
}
const _hoisted_11 = { class: "block-card block-card--bg-light-grey" }
const _hoisted_12 = { class: "premium-box block-card__content" }
const _hoisted_13 = { class: "country-container" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "ekn-risk-stats" }

import { computed } from "vue";
import { usePremCalcStore } from "@premcalc/store/premCalcStore";
import CountryRisk from "./countryRisk.vue";
import PolicyDefinition from "./policyDefinition.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'countryInfo',
  setup(__props) {

const store = usePremCalcStore();

const riskClass = computed(() => store.currentCountryInfo?.countryRiskClassViewModel);
const policyInstructions = computed(() => store.currentCountryInfo?.riskPoliciesInstructionsViewModel);
const countryPolicies = computed(() => store.currentCountryInfo?.countryRiskClassViewModel?.countryPolicyModel);
const translations = computed(() => store.translations?.policies);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(riskClass.value?.riskClassTitleText), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(riskClass.value?.riskClassValue), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (n) => {
                return _createElementVNode("li", {
                  key: n,
                  class: _normalizeClass({ active: n - 1 === riskClass.value?.riskClassValue })
                }, _toDisplayString(n - 1), 3 /* TEXT, CLASS */)
              }), 64 /* STABLE_FRAGMENT */))
            ]),
            (riskClass.value?.riskClassDescription)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(riskClass.value?.riskClassDescription), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("table", null, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(translations.value?.country), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(riskClass.value?.country), 1 /* TEXT */)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(translations.value?.riskAnalyses), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(riskClass.value?.riskClassValue) + " " + _toDisplayString(_unref(store).translations?.of) + " 7", 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(translations.value?.riskType), 1 /* TEXT */),
              _createElementVNode("th", null, _toDisplayString(translations.value?.sortTerm), 1 /* TEXT */),
              _createElementVNode("th", null, _toDisplayString(translations.value?.longTerm), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createVNode(CountryRisk, {
              riskTitle: translations.value?.riskSovereign,
              riskShort: countryPolicies.value?.policySovereignRiskShort,
              riskLong: countryPolicies.value?.policySovereignRiskLong
            }, null, 8 /* PROPS */, ["riskTitle", "riskShort", "riskLong"]),
            _createVNode(CountryRisk, {
              riskTitle: translations.value?.riskOther,
              riskShort: countryPolicies.value?.policyOtherPublicRiskShort,
              riskLong: countryPolicies.value?.policyOtherPublicRiskLong
            }, null, 8 /* PROPS */, ["riskTitle", "riskShort", "riskLong"]),
            _createVNode(CountryRisk, {
              riskTitle: translations.value?.riskBanks,
              riskShort: countryPolicies.value?.policyRiskBanksShort,
              riskLong: countryPolicies.value?.policyRiskBanksLong
            }, null, 8 /* PROPS */, ["riskTitle", "riskShort", "riskLong"]),
            _createVNode(CountryRisk, {
              riskTitle: translations.value?.riskCorporate,
              riskShort: countryPolicies.value?.policyRiskCorporatesShort,
              riskLong: countryPolicies.value?.policyRiskCorporatesLong
            }, null, 8 /* PROPS */, ["riskTitle", "riskShort", "riskLong"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (translations.value?.RiskInstructionsIntro)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_14, _toDisplayString(translations.value?.policies?.riskInstructionsIntro), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (translations.value?.riskInstructionsDescription)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(translations.value?.policies?.riskInstructionsDescription), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(PolicyDefinition, {
              policyDefinition: policyInstructions.value?.riskPoliciesDefinitions.Gray
            }, null, 8 /* PROPS */, ["policyDefinition"]),
            _createVNode(PolicyDefinition, {
              policyDefinition: policyInstructions.value?.riskPoliciesDefinitions.Green
            }, null, 8 /* PROPS */, ["policyDefinition"]),
            _createVNode(PolicyDefinition, {
              policyDefinition: policyInstructions.value?.riskPoliciesDefinitions.Yellow
            }, null, 8 /* PROPS */, ["policyDefinition"]),
            _createVNode(PolicyDefinition, {
              policyDefinition: policyInstructions.value?.riskPoliciesDefinitions.Red
            }, null, 8 /* PROPS */, ["policyDefinition"]),
            _createVNode(PolicyDefinition, {
              policyDefinition: policyInstructions.value?.riskPoliciesDefinitions.Blue
            }, null, 8 /* PROPS */, ["policyDefinition"])
          ])
        ])
      ])
    ])
  ]))
}
}

})